import { ApiProperty } from "@nestjs/swagger";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { EmployeeExperienceDetails } from "../employee-details/employee-experience-details.entity";
import { EmployeeIdProofDetails } from "../employee-details/employee-id-proof-details.entity";
import { Product } from "../products/product.entity";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";
import { PackingCategoryEnum } from "@gtpl/shared-models/common-models";
import { FgPriceListCategoryEnum } from "@gtpl/shared-models/masters";
import {  PackingMaterialPricesLogs } from "./packing-material-prices-logs-entity";
import { SkuCodes } from "../sku-codes/sku-codes.entity";

@Entity('packing_material_prices')
export class PackingMaterialPricesEntity{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    
  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: false,
    name: "price"
  })
  price: number;
   
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
  
  // @Column("enum", {
  //   nullable: false,
  //   name: "category",
  //   enum:FgPriceListCategoryEnum
  // })
  // category: FgPriceListCategoryEnum;

  @ManyToOne(type=>SkuCodes, e=>e.packingMaterialInfo,{  nullable:false, })
    @JoinColumn({ name:"product_id"})
    productId: SkuCodes;

    @ManyToOne(type=>PackingMethod, e=>e.packingMaterialInfo,{ nullable:false, })
    @JoinColumn({ name:"pack_style_id"})
    packingStyleId: PackingMethod;
    @OneToMany(type => PackingMaterialPricesLogs, info => info.PackingMaterialPricesId, { cascade: true })
    packingMaterialInfo: PackingMaterialPricesLogs[];
}